/**
 * Video Configuration
 * Constants for Wistia video player configuration
 */

export const VIDEO_CONFIG = {
  // Video IDs
  MOBILE_VIDEO_ID: 'fp3yohihpp',
  DESKTOP_VIDEO_ID: 'kxppgl7zzn',
  EXPLAINER_VIDEO_ID: 'wzptkam6jw',

  // Breakpoints
  MOBILE_BREAKPOINT: 768,

  // Timeouts
  SCRIPT_TIMEOUT_MS: 15000,
  VIDEO_READY_TIMEOUT_MS: 10000,

  // Default video options
  DEFAULT_OPTIONS: {
    'data-video-width': '100%',
    'data-video-height': '100%',
    'data-fit-strategy': 'cover',
    'data-player-color': '000000',
    'data-autoplay': 'muted',
    'data-muted': '1',
    'data-loop': '1',
    'data-controls': '0',
    'data-playbar': '0',
    'data-fullscreen-button': '0',
    'data-small-play-button': '0',
    'data-playsinline': '1',
    'data-preload': 'auto',
    'data-end-video-behavior': 'loop',
    'data-allow-unmute-overlay': '0',
    'data-video-fallback': '1',
    'data-click-to-play': '0',
    'data-play-button': '0',
  },

  // Wistia script URL
  SCRIPT_URL: 'https://fast.wistia.com/assets/external/E-v1.js',
  PLAYER_SCRIPT_URL: 'https://fast.wistia.com/player.js',
};

export default VIDEO_CONFIG;
